<!--远程会诊待处理页面-->
<template>
    <div class="consul-deal clearfix">
        <!--<div class="deal-content marginP " v-if="!isEnterVideo">
            <div class="part-left part fl">
                <div class="video-Top">
                    <label class="searchTip">待处理</label>
                </div>
                <div class="part-left-content">
                    <div class="search-warp">
                        <input type="search" class="search-input" placeholder="搜索">
                        <button class="search-btn"></button>
                    </div>
                    <ul class="part-left-list">
                        <li class="part-left-item" v-for="item in consultList" :key="item.consultId">
                            <div class="item-a">
                                <img class="item-pic">
                                <span class="item-name">{{ item.consulterName }}</span>
                                <span class="item-sex">{{ item.consulterGender =="M"?"男":"女" }}</span>
                                <span class="item-age">{{ item.consulterAge }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="part-right consul-deal-part part mypatient">
                <router-view @showList="showList"></router-view>
            </div>
        </div>-->
        <div class="deal-content marginP " >
            <div class="part-left part fl" v-loading="isSuccess" v-if="isEnterVideo">
                <div class="video-Top">
                    <label class="searchTip">视频会诊间</label>
                </div>
                <div class="part-left-content">
                    <div class=" blue-btn-wrap clearfix">
                        <el-button type="small" class="fl marginL15 marginT10 blue-btn" @click="inviteVideo">邀请会诊</el-button>
                    </div>
                    <ul class="part-left-list">
                        <li class="part-left-item" v-for="(item,index) in roomList" :key="index">
                            <div class="item-a">
                                <!--<img class="item-pic">-->
                                <img class="item-pic fl" :src="item.userGender =='M'?require('../../../images/M-icon.png'):require('../../../images/F-icon.png')">
                                <span class="item-name marginL5 fontBold jet-black lineH25">{{ item.userName }}</span>
                                <span class="item-sex marginL5">{{ item.userGender =="M"?"男":"女" }}</span>
                                <span class="item-age">{{ item.userAge }}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="video-Top">
                    <label class="searchTip">系统消息</label>
                </div>
                <WebChatCmp :small="true" :consultId="consultId" type="group" />
            </div>
            <div class="part-right consul-deal-part mypatient">
                <router-view @showList="showList" @hiddenList="hiddenList"></router-view>
            </div>
            <AddDoctorMsgBox v-if="isShowAddDocBox" @hide="hiddenAddDocBox" type="remoteVideo" :consultId="consultId"/>
        </div>
    </div>
</template>
<style>

</style>
<script>
    import WebChatCmp from "../common/WebChatCmp.vue";
    import AddDoctorMsgBox from "../common/AddDoctorMsgBox.vue";
    import axiosUtil from "../../utils/AxiosUtils.js"
    import { Message, Loading } from "element-ui";
    import Vue from "vue";
    Vue.use(Loading);
    export default{
        data: function(){
            return {
                isShowAddDocBox: false,
                isEnterVideo: false,//是否显示人员及聊天侧边款
                isSuccess: false,//获取会诊间列表是否成功
                roomList: [],//会诊间人员列表
            }

        },
        computed: {
            consultId: function(){//获取会诊单编号
                return this.$route.params.consultId;//获取会诊单编号
            },
            consultList: function(){
                return this.$store.state.currentConsultList;
            },
        },
        components:{
            WebChatCmp,
            AddDoctorMsgBox
        },
        mounted: function(){//显示房间列表和对话框之前调用该钩子函数 在其中调用会诊参会人员列表
            /*this.isSuccess = true;
            let _this = this;
            let options = {
                consultId: _this.consultId,
                token: localStorage.getItem("token"),

                Service: "smarthos.consult.group.invite.list"
            };
            axiosUtil(options, function(data){
                _this.isSuccess = false;
                _this.roomList = data.list;

            });*/
        },
        methods: {
            linkToPatientInfo: function(ev, currentPatientId){//点击个人档案
                let e = ev || event;
                if(e.preventDefault){
                    e.preventDefault();
                    e.stopPropagation();
                }else {
                    e.cancelBubble = true;//停止冒泡
                    e.returnValue = false;//阻止事件的默认行为
                }
                this.$router.push({ name: "remoteToDealInfo", params: { patientId: currentPatientId }});
            },
            hiddenAddDocBox: function(){//隐藏要求会诊框
                this.isShowAddDocBox = false;
            },
            inviteVideo: function(){//邀请会诊
                this.isShowAddDocBox = true;
            },
            showList: function(){//显示左侧人员列表及聊天框
                this.isSuccess = true;
                let _this = this;
                let options = {
                    consultId: _this.consultId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.invite.list"
                };
                axiosUtil(options, function(data){
                    _this.isSuccess = false;
                    _this.roomList = data.list;
                    _this.isEnterVideo = true;
                }, function(){
                    _this.isSuccess = false;
                });
            },
            hiddenList: function () {
                this.isEnterVideo = false;
            }

        }
    }
</script>
